import React from 'react';
import PropTypes from 'prop-types';
import Link from '../Link';
import { isReleased } from '../../data/widgets/release';

/**
 * Ссылка, которая исчезает, пока страница не открыта.
 *
 * Страницы из очереди поэтапной публикации до своей даты отдают 404, поэтому
 * обычный <Link> на них — это битая ссылка на каждой странице сайта. Здесь
 * вместо ссылки остаётся просто текст: предложение читается как было, а
 * робот и человек никуда не проваливаются.
 *
 * @see src/data/widgets/release.js
 */
export default function StagedLink({ to, children, ...rest }) {
	const id =
		to.indexOf('/widgets/') === 0 ? to.slice('/widgets/'.length) : to;

	if (!isReleased(id)) {
		return <React.Fragment>{children}</React.Fragment>;
	}

	return (
		<Link to={to} {...rest}>
			{children}
		</Link>
	);
}

StagedLink.propTypes = {
	to: PropTypes.string.isRequired,
	children: PropTypes.node.isRequired,
};
